import { memo, JSX } from 'react';
import { useMobileView, t } from '@bg-shared';

interface IProps {
    translationKey: string;
    className?: string;
}

export const MediaQueryTitle = memo((props: IProps): JSX.Element => {
    const isMobileView = useMobileView();

    if (isMobileView) {
        return null;
    }

    return <span className={props.className}>{t.string(props.translationKey)}</span>;
});
